@let forbidden = forbidden$ | async;

<app-header-post>
  <div class="@container">
    <span class="font-semibold text-xl md:text-3xl">{{ header.plural | translate }}</span>
    <span class="hidden @post:inline pl-1 text-subtitle text-2xl" translate>eclass.agenda.filtros.caixa-entrada</span>
  </div>
</app-header-post>

@if (forbidden) {
  <app-card-forbidden class="w-full" [forbidden]="forbidden"></app-card-forbidden>
} @else {
  <app-posts-filter-bar [config]="filter" (refresh)="onFilter($event)" class="px-7 flex w-full"> </app-posts-filter-bar>

  <div class="flex justify-center p-4" *isAllow="[20, 41]">
    <div class="flex rounded-full overflow-hidden w-full max-w-xs shadow-sm">
      <button
        (click)="onFilterType(type.Received)"
        class="flex-1 flex items-center justify-center gap-2 py-2 text-md font-medium transition-all duration-200 border-none outline-none cursor-pointer"
        [ngClass]="{
          'bg-modules-school-500 text-white shadow-inner': filterType() === type.Received,
          'bg-white text-modules-school-500': filterType() !== type.Received,
        }"
      >
        <svg-icon [src]="'icon-received' | icon" class="h-5 w-5"></svg-icon>
        {{ 'geral.recebidos' | translate }}
      </button>
      <div class="w-px bg-modules-school-500"></div>
      <button
        (click)="onFilterType(type.Sent)"
        class="flex-1 flex items-center justify-center gap-2 py-2 text-md font-medium transition-all duration-200 border-none outline-none cursor-pointer"
        [ngClass]="{
          'bg-modules-school-500 text-white shadow-inner': filterType() === type.Sent,
          'bg-white text-modules-school-500': filterType() !== type.Sent,
        }"
      >
        <svg-icon [src]="'icon-sent' | icon" class="h-5 w-5"></svg-icon>
        {{ 'geral.enviados' | translate }}
      </button>
    </div>
  </div>

  <div class="flex flex-col gap-1 overflow-y-scroll py-1 px-5 pb-40 lg:pb-5 flex-1 min-h-0">
    <app-accordion [multi]="true" class="flex flex-col gap-6">
      @for (data of data(); track data.date) {
        <app-accordion-item [expanded]="true" headerClass="bg-base-gray-light-200! rounded-2xl! py-2!">
          <div app-accordion-header class="uppercase text-title" [ngClass]="{ 'font-semibold': data.is_today }">
            @if (data.is_today) {
              {{ 'geral.hoje' | translate }} -
            }
            {{ data.date | dateTranslate: 'EEEE, dd/MMM' }}
            @if (data.count) {
              <span class="border rounded-full px-2 bg-base-gray-100">{{ data.count }}</span>
            }
          </div>

          <div app-accordion-content class="flex flex-col gap-1">
            @for (item of data.items; track item.id) {
              <app-item-post [item]="item"></app-item-post>
            } @empty {
              <app-posts-jumbotron
                [showIcon]="false"
                [title]="'geral.nenhum-dado' | translate"
                class="h-15! border-dashed border-2"
              ></app-posts-jumbotron>
            }
          </div>
        </app-accordion-item>
      } @empty {
        @if (!loading()) {
          <app-posts-jumbotron
            [icon]="header.icon"
            [title]="'geral.nenhum-dado' | translate"
            class="h-80!"
          ></app-posts-jumbotron>
        }
      }
    </app-accordion>
    @if (loading()) {
      @for (item of [1, 2, 3, 4, 5]; track $index) {
        <app-skeleton [showIcon]="false" class="block h-[60px]! w-full"></app-skeleton>
      }
    }
  </div>
}
